import { icons } from '../../assets/assets';
import GameMaterialItem from './GameMaterialItem';

export default class PasswordGameMaterial extends GameMaterialItem {
  constructor(props) {
    super(props);
    this.state.loading = false;
    this.state.icons = [{
        src: icons.greyLock,
        alt: 'icon',
        onClick: this.handleClick,
    }];
    this.handleClick = () => {
        window.open(`/portal/password/${props.item.id}`, '_blank');
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/PasswordGameMaterial.js